module["exports"] = [
  "#{Name.first_name}#{street_suffix}",
  "#{Name.last_name}#{street_suffix}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ja/address/street_name.js
 ** module id = 712
 ** module chunks = 0
 **/